<template>
  <div id="wrapper" class="page" v-if="hoso_report">
    <div id="content-wrapper" style="height: 100%;">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#" @click.prevent>
            <span>
              Report
              <!-- Báo cáo hồ sơ -->
            </span>
          </a>
        </li>
      </ol>
      <div class="container-fluid">
        <div class="form-inline">
          <button class="btn btn-info mb-2" @click.prevent="openModal">
            <i class="far fa-file-alt"></i>
            Select Report
            <!-- Chọn báo cáo -->
          </button>
          <div style="flex-grow: 1" class="text-center"></div>
          <button
            v-if="report != null"
            class="btn btn-success"
            @click.prevent="excelReport"
          >
            <i class="far fa-file-excel"></i>
            Export to Excel
            <!-- Xuất excel -->
          </button>
        </div>
        <!-- View IndexReportX -->
        <!-- Mẫu 01 - Danh sách nhân viên đang làm việc -->
        <report1 v-if="report == 1"></report1>
        <!-- Mẫu 02 - Danh sách nhân viên theo thâm niên-->
        <report2 v-if="report == 2" :toDateThamNien="toDateThamNien"></report2>
        <!-- Mẫu 03 - Danh sách nhân nhân thân nhân viên-->
        <report3 v-if="report == 3"></report3>
        <!-- Mẫu 04 - Báo cáo thống kế biến động nhân sự -->
        <report4
          v-if="report == 4"
          :fromDateBienDong="fromDateBienDong"
          :toDateBienDong="toDateBienDong"
          :status="tinhTrang_Report4"></report4>
        <!-- Mẫu 05 - Danh sách nhân viên sinh nhật -->
        <report5
          v-if="report == 5"
          :fromDateBirthday="fromDateBirthday"
          :toDateBirthday="toDateBirthday"
        ></report5>

        <!-- Mẫu 06 - Danh sách nhân viên nghỉ việc -->
        <report6 v-if="report == 6"></report6>

        <!-- Mẫu 07 - Danh sách tổng hợp -->
        <report7 v-if="report == 7"></report7>

        <!-- Mẫu 06 old - Danh sách nhân viên chưa ký hợp đồng -->
        <!-- <report6 v-if="report == 6" :toDateChuaKyHD="toDateChuaKyHD"></report6> -->

        <!-- Mẫu 07 old - Danh sách nhân viên sắp hết hạn hợp đồng -->
        <!-- <report7
          v-if="report == 7"
          :toDateSapHetHanHD="toDateSapHetHanHD"
          :inDays="inDays_Report7"
          :loaihopdongs="loaihopdongs"
          :loaihopdong="loaihopdong"
        ></report7> -->
        <!-- Mẫu 08 - Danh sách nhân viên có HĐLD quá hạn chưa xử lý -->
        <report8
          v-if="report == 8"
          :toDateQuaHan="toDateQuaHan"
          :loaihopdongs="loaihopdongs"
          :loaihopdong="loaihopdong"
        ></report8>
        <!-- Mẫu 09 - Danh sách nhân viên có thay đổi lương -->
        <report9
          v-if="report == 9"
          :fromDateThayDoiLuong="fromDateThayDoiLuong"
          :toDateThayDoiLuong="toDateThayDoiLuong"
        ></report9>

        <!-- <report10 v-if="report == 10" :employee="employee">
        </report10> -->
        <report10 v-if="report == 10" :employee="kyBaocao_Report10"></report10>

        <!-- Mẫu 11 - Thống kê lương và các khoản phụ cấp -->
        <report11 v-if="report == 11"></report11>
      </div>
    </div>
    <b-modal
      v-model="modalShow"
      header-bg-variant="primary"
      header-text-variant="light"
      hide-footer
      title="REPORT"
      text-center
    >
      <b-form autocomplete="false">
        <!-- Chon "Loai bao cao" -->
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b>
                  Report Type
                  <!-- Loại báo cáo -->
                </b>
                <span class="text-danger"> *</span>
              </template>
              <b-form-select v-model="reportKind" @change="changeReportKind">
                <b-form-select-option
                  v-if="hoso_report1 || hoso_report_all"
                  value="1"
                  >Mẫu 01 - Danh sách nhân viên đang làm
                  việc</b-form-select-option
                >
                <b-form-select-option
                  v-if="hoso_report2 || hoso_report_all"
                  value="2"
                  >Mẫu 02 - Danh sách nhân viên theo thâm niên công
                  tác</b-form-select-option
                >
                <b-form-select-option
                  v-if="hoso_report3 || hoso_report_all"
                  value="3"
                  >Mẫu 03 - Danh sách nhân thân nhân viên</b-form-select-option
                >
                <b-form-select-option
                  v-if="hoso_report4 || hoso_report_all"
                  value="4"
                  >Mẫu 04 - Báo cáo biến động nhân
                  sự</b-form-select-option
                >
                <b-form-select-option
                  v-if="hoso_report5 || hoso_report_all"
                  value="5"
                  >Mẫu 05 - Danh sách sinh nhật nhân viên</b-form-select-option
                >
                <b-form-select-option
                  v-if="hoso_report6 || hoso_report_all"
                  value="6"
                  >Mẫu 06 - Danh sách nhân viên nghỉ việc
                </b-form-select-option>

                <b-form-select-option
                  v-if="hoso_report7 || hoso_report_all"
                  value="7"
                  >Mẫu 07 - Danh sách tổng hợp
                </b-form-select-option>
                <!-- @Edit Thanh hide bao cao 6 old/7old/8/9/10/11 -->
                <!-- <b-form-select-option
                  v-if="hoso_report6 || hoso_report_all"
                  value="6"
                  >Mẫu 06 - Danh sách nhân viên chưa ký hợp
                  đồng</b-form-select-option
                >
                <b-form-select-option
                  v-if="hoso_report7 || hoso_report_all"
                  value="7"
                  >Mẫu 07 - Danh sách nhân viên sắp hết hạn hợp
                  đồng</b-form-select-option
                >
                <b-form-select-option
                  v-if="hoso_report8 || hoso_report_all"
                  value="8"
                  >Mẫu 08 - Danh sách nhân viên quá hạn hợp
                  đồng</b-form-select-option
                >
                <b-form-select-option
                  v-if="hoso_report9 || hoso_report_all"
                  value="9"
                  >Mẫu 09 - Danh sách nhân viên có thay đổi lương
                </b-form-select-option>
                <b-form-select-option
                  v-if="hoso_report10 || hoso_report_all"
                  value="10"
                  >Mẫu 10 - Báo cáo quá trình làm việc của nhân viên
                </b-form-select-option>
                <b-form-select-option
                  v-if="hoso_report11 || hoso_report_all"
                  value="11"
                  >Mẫu 11 - Thống kê lương và các khoản phụ cấp
                </b-form-select-option> -->
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Option for Report Kind -->

        <!-- Report2: Tham nien -->
        <!-- @Edit Thanh hide Ky bao cao -->
        <!-- <b-row v-if="reportKind == 2">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b>Kỳ báo cáo</b>
                <span class="text-danger"> *</span>
              </template>
              <b-form-select
                v-model="kyBaoCao_Report2"
                :options="optionsKyBaoCao_Report2"
                @change="changeKyBaoCao_Report2"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row> -->
        <b-row v-if="reportKind == 2">
          <b-col cols="8">
            <b-form-group>
              <template v-slot:label>
                <b>
                  To date
                  <!-- Đến ngày -->
                </b>
                <span class="text-danger"> *</span>
              </template>
              <vue-datepicker-local
                style="width: 45%"
                v-model="toDateThamNien"
                :local="local"
                clearable
                format="DD/MM/YYYY"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Report4: Bien dong -->
        <b-row v-if="reportKind == 4">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b>
                  Period
                  <!-- Kỳ báo cáo -->
                </b>
                <span class="text-danger"> *</span>
              </template>
              <b-form-select
                v-model="kyBaoCao_Report4"
                :options="optionsKyBaoCao_Report4"
                @change="changeKyBaoCao_Report4"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="reportKind == 4">
          <b-col cols="6">
            <b-form-group>
              <template v-slot:label>
                <b>
                  From date
                  <!-- Từ ngày -->
                </b>
                <span class="text-danger"> *</span>
              </template>
              <vue-datepicker-local
                style="width: 100%"
                v-model="fromDateBienDong"
                :local="local"
                clearable
                format="DD/MM/YYYY"
              />
              <!-- <my-date-picker v-model="toDate" :required="true"></my-date-picker> -->
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group>
              <template v-slot:label>
                <b>
                  To date
                  <!-- Đến ngày -->
                </b>
                <span class="text-danger"> *</span>
              </template>
              <vue-datepicker-local
                style="width: 100%"
                v-model="toDateBienDong"
                :local="local"
                clearable
                format="DD/MM/YYYY"
              />
            </b-form-group>
          </b-col>
        </b-row>
         <b-row v-if="reportKind == 4">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b>
                  Filter by contract status:
                  <!-- Lọc theo tình trạng HĐ: -->
                </b>
                <span class="text-danger"> *</span>
              </template>
              <b-form-select
                v-model="tinhTrang_Report4"
                :options="optionsTinhTrang_Report4"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Report5: Sinh nhat -->
        <b-row v-if="reportKind == 5">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b>
                  Period
                  <!-- Kỳ báo cáo -->
                </b>
                <span class="text-danger"> *</span>
              </template>
              <b-form-select
                v-model="kyBaoCao_Report5"
                :options="optionsKyBaoCao_Report5"
                @change="changeKyBaoCao_Report5"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="reportKind == 5">
          <b-col cols="6">
            <b-form-group>
              <template v-slot:label>
                <b>
                  From date
                  <!-- Từ ngày -->
                </b>
                <span class="text-danger"> *</span>
              </template>
              <vue-datepicker-local
                style="width: 100%"
                v-model="fromDateBirthday"
                :local="local"
                clearable
                format="DD/MM/YYYY"
              />
              <!-- <my-date-picker v-model="toDate" :required="true"></my-date-picker> -->
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group>
              <template v-slot:label>
                <b>
                  To date
                  <!-- Đến ngày -->
                </b>
                <span class="text-danger"> *</span>
              </template>
              <vue-datepicker-local
                style="width: 100%"
                v-model="toDateBirthday"
                :local="local"
                clearable
                format="DD/MM/YYYY"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Report6 old: Chua ky HD  -->
        <!-- <b-row v-if="reportKind == 6">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b>Kỳ báo cáo</b>
                <span class="text-danger"> *</span>
              </template>
              <b-form-select
                v-model="kyBaoCao_Report6"
                :options="optionsKyBaoCao_Report6"
                @change="changeKyBaoCao_Report6"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="reportKind == 6">
          <b-col cols="8">
            <b-form-group>
              <template v-slot:label>
                <b>Đến ngày</b>
                <span class="text-danger"> *</span>
              </template>
              <vue-datepicker-local
                style="width: 45%"
                v-model="toDateChuaKyHD"
                :local="local"
                clearable
                format="DD/MM/YYYY"
              />
            </b-form-group>
          </b-col>
        </b-row> -->

        <!-- Report7 old: Sap het han HD -->
        <!-- <b-row v-if="reportKind == 7">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b>Loại hợp đồng</b>
                <span class="text-danger"> *</span>
              </template>
              <b-form-select
                v-model="loaihopdong"
                :options="loaihopdongs"
                value-field="id"
                text-field="pickListValue"
              >
                <template>
                  <b-form-select-option :value="null"
                    >Tất cả</b-form-select-option
                  >
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="reportKind == 7">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b>Số ngày sắp hết hạn hợp đồng</b>
                <span class="text-danger"> *</span>
              </template>
              <my-currency-input v-model="inDays_Report7" style="width:50%">
              </my-currency-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="reportKind == 7">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b>Kỳ báo cáo</b>
                <span class="text-danger"> *</span>
              </template>
              <b-form-select
                v-model="kyBaoCao_Report7"
                :options="optionsKyBaoCao_Report7"
                @change="changeKyBaoCao_Report7"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="reportKind == 7">
          <b-col cols="8">
            <b-form-group>
              <template v-slot:label>
                <b>Đến ngày</b>
                <span class="text-danger"> *</span>
              </template>
              <vue-datepicker-local
                style="width: 45%"
                v-model="toDateSapHetHanHD"
                :local="local"
                clearable
                format="DD/MM/YYYY"
              />
            </b-form-group>
          </b-col>
        </b-row> -->

        <!-- Report8: Quá han HD -->
        <b-row v-if="reportKind == 8">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b>Loại hợp đồng</b>
                <span class="text-danger"> *</span>
              </template>
              <b-form-select
                v-model="loaihopdong"
                :options="loaihopdongs"
                value-field="id"
                text-field="pickListValue"
              >
                <!-- <template v-slot:first> -->
                <template>
                  <b-form-select-option :value="null"
                    >Tất cả</b-form-select-option
                  >
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="reportKind == 8">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b>
                  Period
                  <!-- Kỳ báo cáo -->
                </b>
                <span class="text-danger"> *</span>
              </template>
              <b-form-select
                v-model="kyBaoCao_Report8"
                :options="optionsKyBaoCao_Report8"
                @change="changeKyBaoCao_Report8"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="reportKind == 8">
          <b-col cols="8">
            <b-form-group>
              <template v-slot:label>
                <b>
                  To date
                  <!-- Đến ngày -->
                </b>
                <span class="text-danger"> *</span>
              </template>
              <vue-datepicker-local
                style="width: 45%"
                v-model="toDateQuaHan"
                :local="local"
                clearable
                format="DD/MM/YYYY"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Report9: Thay doi luong -->
        <b-row v-if="reportKind == 9">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b>
                  Period
                  <!-- Kỳ báo cáo -->
                </b>
                <span class="text-danger"> *</span>
              </template>
              <b-form-select
                v-model="kyBaoCao_Report9"
                :options="optionsKyBaoCao_Report9"
                @change="changeKyBaoCao_Report9"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="reportKind == 9">
          <b-col cols="6">
            <b-form-group>
              <template v-slot:label>
                <b>
                  From date
                  <!-- Từ ngày -->
                </b>
                <span class="text-danger"> *</span>
              </template>
              <vue-datepicker-local
                style="width: 100%"
                v-model="fromDateThayDoiLuong"
                :local="local"
                clearable
                format="DD/MM/YYYY"
              />
              <!-- <my-date-picker v-model="toDate" :required="true"></my-date-picker> -->
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group>
              <template v-slot:label>
                <b>
                  To date
                  <!-- Đến ngày -->
                </b>
                <span class="text-danger"> *</span>
              </template>
              <vue-datepicker-local
                style="width: 100%"
                v-model="toDateThayDoiLuong"
                :local="local"
                clearable
                format="DD/MM/YYYY"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Report10: Thay doi luong -->
        <b-row v-if="reportKind == 10">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Nhân viên
                <span class="text-danger">*</span>
              </template>
              <!-- <multiselect
                v-model="employee"
                placeholder
                track-by="id"
                label="hovaten"
                selectedLabel="Đang chọn"
                select-label="Enter để chọn"
                deselectLabel="Enter để xóa"
                :searchable="true"
                :options="employees"
                :taggable="true"
              ></multiselect> -->
              <b-form-select
                v-model="kyBaoCao_Report10"
                :options="optionsKyBaoCao_Report10"
                @change="changeKyBaoCao_Report10"
                text-field="name"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Button Select -->
        <b-row>
          <b-col>
            <b-form-group>
              <b-button
                class="mr-2"
                variant="info"
                @click.prevent="selectReport"
              >
                <i class="fas fa-check mr-2"></i>
                Select
                <!-- Chọn -->
              </b-button>
              <b-button
                class="mr-2"
                variant="secondary"
                @click.prevent="closeModal"
              >
                <i class="fas fa-times mr-2"></i>
                Close
                <!-- Đóng -->
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import Report1 from "../components/Employee/Report/Report1";
import Report2 from "../components/Employee/Report/Report2";
import Report3 from "../components/Employee/Report/Report3";
import Report4 from "../components/Employee/Report/Report4";
import Report5 from "../components/Employee/Report/Report5";
import Report6 from "../components/Employee/Report/Report6";
import Report7 from "../components/Employee/Report/Report7";
import Report8 from "../components/Employee/Report/Report8";
import Report9 from "../components/Employee/Report/Report9";
import Report10 from "../components/Employee/Report/Report10";
import Report11 from "../components/Employee/Report/Report11";
// import MyDatePicker from  "../components/App/MyDatePicker";
import MyCurrencyInput from "../components/App/MyCurrencyInput";
import VueDatepickerLocal from "vue-datepicker-local";
import "vue-datepicker-local/dist/vue-datepicker-local.css";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
export default {
  name: "EmployeesReport",
  components: {
    Report1,
    Report2,
    Report3,
    Report4,
    Report5,
    Report6,
    Report7,
    Report8,
    Report9,
    Report10,
    Report11,
    VueDatepickerLocal,
    // Multiselect,
    //MyCurrencyInput,
  },
  data() {
    return {
      optionsReport: [
        // { value: 1, text: "01. Danh sách nhân viên tổng hợp" },
        // Delete for filter departhment { value: 2, text: "02. Danh sách nhân viên theo đơn vị công tác" },
        // { value: 2, text: "02. Danh sách nhân viên theo thâm niên công tác" },
        // { value: 3, text: "03. Báo cáo thống kê biến động nhân sự" },
        // { value: 4, text: "04. Báo cáo sinh nhật" },
        // { value: 5, text: "05. Danh sách nhân viên chưa ký hợp đồng" },
        // { value: 6, text: "06. Danh sách nhân viên sắp hết hạn hợp đồng" },
        // { value: 7, text: "07. Danh sách nhân viên quá hạn hợp đồng" },
        // { value: 8, text: "08. Danh sách nhân viên có thay đổi lương" },
        // { value: 9, text: "09. Báo cáo quá trình làm việc từng nhân viên" },
      ],
      reportKind: null,
      report: null,
      modalShow: false,
      loaihopdongs: [],
      loaihopdong: null,
      employees: [],
      employee: null,
      vitricongviecs: [],
      departments: [],

      //Report 2: Tham nien
      toDateThamNien: new Date(),
      optionsKyBaoCao_Report2: [
        { value: 0, text: "Hôm nay" },
        { value: 1, text: "Ngày mai" },
        { value: 2, text: "Cuối tháng này" },
        { value: 3, text: "Cuối tháng sau" },
      ],
      kyBaoCao_Report2: 0,

      //Report 4: Bien dong
      fromDateBienDong: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        ),
      toDateBienDong: new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
        ),
      optionsKyBaoCao_Report4: [
        // @Edit Thanh
        // { value: 0, text: "Hôm nay" },
        // { value: 1, text: "Ngày mai" },
        { value: 2, text: "Tháng này" },
        // { value: 3, text: "Tháng sau" },
        { value: 4, text: "Tháng 1" },
        { value: 5, text: "Tháng 2" },
        { value: 6, text: "Tháng 3" },
        { value: 7, text: "Tháng 4" },
        { value: 8, text: "Tháng 5" },
        { value: 9, text: "Tháng 6" },
        { value: 10, text: "Tháng 7" },
        { value: 11, text: "Tháng 8" },
        { value: 12, text: "Tháng 9" },
        { value: 13, text: "Tháng 10" },
        { value: 14, text: "Tháng 11" },
        { value: 15, text: "Tháng 12" },
        { value: 16, text: "Quý I" },
        { value: 17, text: "Quý II" },
        { value: 18, text: "Quý III" },
        { value: 19, text: "Quý IV" },
      ],
      kyBaoCao_Report4: 2, //default tháng này
      tinhTrang_Report4: 0,
      optionsTinhTrang_Report4: [
         { value: 0, text: "Tất cả" },
         { value: 1, text: "Nghỉ việc" },
         { value: 2, text: "Thử việc" },
         { value: 3, text: "Thực tập" },
         { value: 4, text: "Quá hạn HĐ" },
         { value: 5, text: "Ký mới HĐ" },

      ],

      //Report 5: Sinh nhat
      fromDateBirthday: new Date(new Date().getFullYear(), 0, 1),
      toDateBirthday: new Date(new Date().getFullYear(), 0, 31),
      optionsKyBaoCao_Report5: [
        { value: 0, text: "Tháng 1" },
        { value: 1, text: "Tháng 2" },
        { value: 2, text: "Tháng 3" },
        { value: 3, text: "Tháng 4" },
        { value: 4, text: "Tháng 5" },
        { value: 5, text: "Tháng 6" },
        { value: 6, text: "Tháng 7" },
        { value: 7, text: "Tháng 8" },
        { value: 8, text: "Tháng 9" },
        { value: 9, text: "Tháng 10" },
        { value: 10, text: "Tháng 11" },
        { value: 11, text: "Tháng 12" },
      ],
      kyBaoCao_Report5: 0,

      // Report 6 old: Chua ky hop dong
      // toDateChuaKyHD: new Date(),
      // optionsKyBaoCao_Report6: [
      //   { value: 0, text: "Hôm nay" },
      //   { value: 1, text: "Ngày mai" },
      //   { value: 2, text: "Cuối tháng này" },
      //   { value: 3, text: "Cuối tháng sau" },
      // ],
      // kyBaoCao_Report6: 0,

      //Report 7 old: Sap het han hop dong
      // toDateSapHetHanHD: new Date(),
      // optionsKyBaoCao_Report7: [
      //   { value: 0, text: "Hôm nay" },
      //   { value: 1, text: "Ngày mai" },
      //   { value: 2, text: "Cuối tháng này" },
      //   { value: 3, text: "Cuối tháng sau" },
      // ],
      // kyBaoCao_Report7: 0,
      // inDays_Report7: 30,

      //Report 8: Qua han hop dong
      toDateQuaHan: new Date(),
      optionsKyBaoCao_Report8: [
        { value: 0, text: "Hôm nay" },
        { value: 1, text: "Ngày mai" },
        { value: 2, text: "Cuối tháng này" },
        { value: 3, text: "Cuối tháng sau" },
      ],
      kyBaoCao_Report8: 0,

      //Report 9: Thay doi luong
      fromDateThayDoiLuong: new Date(),
      toDateThayDoiLuong: new Date(),
      optionsKyBaoCao_Report9: [
        { value: 0, text: "Hôm nay" },
        { value: 1, text: "Tháng này" },
        { value: 2, text: "Năm nay" },
        { value: 3, text: "Tháng trước" },
        { value: 4, text: "Năm trước" },
        { value: 5, text: "Tháng 1" },
        { value: 6, text: "Tháng 2" },
        { value: 7, text: "Tháng 3" },
        { value: 8, text: "Tháng 4" },
        { value: 9, text: "Tháng 5" },
        { value: 10, text: "Tháng 6" },
        { value: 11, text: "Tháng 7" },
        { value: 12, text: "Tháng 8" },
        { value: 13, text: "Tháng 9" },
        { value: 14, text: "Tháng 10" },
        { value: 15, text: "Tháng 11" },
        { value: 16, text: "Tháng 12" },
        { value: 17, text: "Quý I" },
        { value: 18, text: "Quý II" },
        { value: 19, text: "Quý III" },
        { value: 20, text: "Quý IV" },
      ],
      kyBaoCao_Report9: 0,

      kyBaocao_Report10: null,
      optionsKyBaoCao_Report10: [{ name: "Tất cả", value: null }],

      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ), // months of head
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ), // months of panel
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"), // weeks,
      },

      reportType: 0,
    };
  },
  // Edit @Thanh
  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get(`/api/picklist?q=vitricongviec|loaihopdong|tinhtranghoso`),
        axios.get(`/api/department`),
        axios.get(`/api/employee`, { params: to.query }),
      ])
      .then(
        axios.spread((picklist, department, item) => {
          next((vm) => vm.initData(picklist.data, department.data, item.data));
        })
      );
  },
  //   beforeRouteUpdate(to, from, next) {
  //   },
  computed: {
    //Permission
    hoso_report() {
      return this.$store.getters.hasPermission("hoso_report");
    },
    hoso_report_all() {
      return this.$store.getters.hasPermission("hoso_report_all");
    },
    hoso_report1() {
      return this.$store.getters.hasPermission("hoso_report1");
    },
    hoso_report2() {
      return this.$store.getters.hasPermission("hoso_report2");
    },
    hoso_report3() {
      return this.$store.getters.hasPermission("hoso_report3");
    },
    hoso_report4() {
      return this.$store.getters.hasPermission("hoso_report4");
    },
    hoso_report5() {
      return this.$store.getters.hasPermission("hoso_report5");
    },
    hoso_report6() {
      return this.$store.getters.hasPermission("hoso_report6");
    },
    hoso_report7() {
      return this.$store.getters.hasPermission("hoso_report7");
    },
    // hoso_report8() {
    //   return this.$store.getters.hasPermission("hoso_report8");
    // },
    // hoso_report9() {
    //   return this.$store.getters.hasPermission("hoso_report9");
    // },
    // hoso_report10() {
    //   return this.$store.getters.hasPermission("hoso_report10");
    // },
    // hoso_report11() {
    //   return this.$store.getters.hasPermission("hoso_report11");
    // },
  },
  methods: {
    initData(picklists, departments, data) {
      this.vitricongviecs = picklists.filter(
        (x) => x.pickListType == "vitricongviec"
      );
      this.loaihopdongs = picklists.filter(
        (x) => x.pickListType == "loaihopdong"
      );
      this.tinhtranghosos = picklists.filter(
        (x) => x.pickListType == "tinhtranghoso"
      );
      this.departments = departments;
      this.items = data.items;
      //Neu la bao cao sinh nhat
      this.reportType = this.$route.params.id;
      if (this.reportType == 5) {
        this.reportKind = 5;
        this.openModal();
      }
    },
    openModal() {
      this.modalShow = true;
      this.report = null;
    },
    closeModal() {
      this.modalShow = false;
      //Report 2: Tham nien
      this.toDateThamNien = new Date();
      this.kyBaoCao_Report2 = 0;
      //Report 4: BienDong
      // this.fromDateBienDong = new Date();
      // this.toDateBienDong = new Date();
      this.fromDateBienDong = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        );
        this.toDateBienDong = new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
        );
      this.kyBaoCao_Report4 = 2;
      this.tinhTrang_Report4 = 0;

      //Report 5: Sinh nhat
      this.fromDateBirthday = new Date(new Date().getFullYear(), 0, 1);
      this.toDateBirthday = new Date(new Date().getFullYear(), 0, 31);
      this.kyBaoCao_Report5 = 0;
      //Report 6 old: Chua ky HD
      // this.toDateChuaKyHD = new Date();
      // this.kyBaoCao_Report6 = 0;

      //Report 7 old: Sap het han HD
      // this.inDays_Report7 = 30;
      // this.toDateSapHetHanHD = new Date();
      // this.kyBaoCao_Report7 = 0;

      //Report 8: Qua han HD
      this.toDateQuaHan = new Date();
      this.kyBaoCao_Report8 = 0;

      //Report 9: Thay doi luong
      this.fromDateThayDoiLuong = new Date();
      this.toDateThayDoiLuong = new Date();
      this.kyBaoCao_Report9 = 0;

      this.loaihopdong = null;
    },
    selectReport() {
      // REPORT 2
      if (this.reportKind == 2 && this.toDateThamNien == "") {
        this.$toast.error("Vui lòng chọn ĐẾN NGÀY 2", "Lỗi", { timeout: 2000 });
        return;
      }
      //REPORT 4
      if (this.reportKind == 4 && this.fromDateBienDong == "") {
        this.$toast.error("Vui lòng chọn TỪ NGÀY", "Lỗi", { timeout: 2000 });
        return;
      }
      if (this.reportKind == 4 && this.toDateBienDong == "") {
        this.$toast.error("Vui lòng chọn ĐẾN NGÀY", "Lỗi", { timeout: 2000 });
        return;
      }
      if (this.fromDateBienDong > this.toDateBienDong) {
        this.$toast.error("Vui lòng chọn ĐẾN NGÀY lớn hơn TỪ NGÀY", "Lỗi", {
          timeout: 2000,
        });
        return;
      }
      //REPORT 5
      if (this.reportKind == 5 && this.fromDateBirthday == "") {
        this.$toast.error("Vui lòng chọn TỪ NGÀY", "Lỗi", { timeout: 2000 });
        return;
      }
      if (this.reportKind == 5 && this.toDateBirthday == "") {
        this.$toast.error("Vui lòng chọn ĐẾN NGÀY", "Lỗi", { timeout: 2000 });
        return;
      }
      if (this.fromDateBirthday > this.toDateBirthday) {
        this.$toast.error("Vui lòng chọn ĐẾN NGÀY lớn hơn TỪ NGÀY", "Lỗi", {
          timeout: 2000,
        });
        return;
      }
      // REPORT 6
      // if (this.reportKind == 6 && this.toDateChuaKyHD == "") {
      //   this.$toast.error("Vui lòng chọn ĐẾN NGÀY", "Lỗi", { timeout: 2000 });
      //   return;
      // }
      // REPORT 7
      // if (this.reportKind == 7 && this.inDays_Report7 == "") {
      //   this.$toast.error("Vui lòng chọn SỐ NGÀY SẮP HẾT HẠN HỢP ĐỒNG", "Lỗi", {
      //     timeout: 2000,
      //   });
      //   return;
      // }
      // if (this.reportKind == 7 && this.toDateSapHetHanHD == "") {
      //   this.$toast.error("Vui lòng chọn ĐẾN NGÀY", "Lỗi", { timeout: 2000 });
      //   return;
      // }

      //REPORT 8
      if (this.reportKind == 8 && this.toDateQuaHan == "") {
        this.$toast.error("Vui lòng chọn ĐẾN NGÀY", "Lỗi", { timeout: 2000 });
        return;
      }

      //REPORT 9
      if (this.reportKind == 9 && this.fromDateThayDoiLuong == "") {
        this.$toast.error("Vui lòng chọn TỪ NGÀY", "Lỗi", { timeout: 2000 });
        return;
      }
      if (this.reportKind == 9 && this.toDateThayDoiLuong == "") {
        this.$toast.error("Vui lòng chọn ĐẾN NGÀY", "Lỗi", { timeout: 2000 });
        return;
      }
      if (this.fromDateThayDoiLuong > this.toDateThayDoiLuong) {
        this.$toast.error("Vui lòng chọn ĐẾN NGÀY lớn hơn TỪ NGÀY", "Lỗi", {
          timeout: 2000,
        });
        return;
      }

      // REPORT 10
      // if (this.reportKind == 10 && this.employee == null) {
      //   this.$toast.error("Vui lòng chọn nhân viên", "Lỗi", { timeout: 2000 });
      //   return;
      // }

      this.report = this.reportKind;
      this.modalShow = false;
    },

    //Report 2: Change option Ky Bao Cao Report 2
    changeKyBaoCao_Report2() {
      //Today
      if (this.kyBaoCao_Report2 == 0) {
        this.toDateThamNien = new Date();
      }
      //Tomorrow
      else if (this.kyBaoCao_Report2 == 1) {
        this.toDateThamNien = new Date().setDate(new Date().getDate() + 1);
      }
      //End of this month
      else if (this.kyBaoCao_Report2 == 2) {
        this.toDateThamNien = new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
        );
      }
      //End of next month
      else if (this.kyBaoCao_Report2 == 3) {
        let toDate = new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
        );
        this.toDateThamNien = new Date(toDate.setMonth(toDate.getMonth() + 1));
      }
    },
    //Report 4: Change option Ky Bao Cao Report 4
    changeKyBaoCao_Report4() {
      //Today
      if (this.kyBaoCao_Report4 == 0) {
        this.fromDateBienDong = new Date();
        this.toDateBienDong = new Date();
      }
      //Tomorrow
      else if (this.kyBaoCao_Report4 == 1) {
        this.fromDateBienDong = new Date().setDate(new Date().getDate() + 1);
        this.toDateBienDong = new Date().setDate(new Date().getDate() + 1);
      }
      //This month
      else if (this.kyBaoCao_Report4 == 2) {
        this.fromDateBienDong = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        );
        this.toDateBienDong = new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
        );
      }
      //Next month
      else if (this.kyBaoCao_Report4 == 3) {
        let fromDate = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        );
        let toDate = new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
        );
        this.fromDateBienDong = new Date(
          fromDate.setMonth(fromDate.getMonth() + 1)
        );
        this.toDateBienDong = new Date(toDate.setMonth(toDate.getMonth() + 1));
      }
      //4.Thang 1
      else if (this.kyBaoCao_Report4 == 4) {
        this.fromDateBienDong = new Date(new Date().getFullYear(), 0, 1);
        this.toDateBienDong = new Date(new Date().getFullYear(), 0, 31);
      }
      //5.Thang 2
      else if (this.kyBaoCao_Report4 == 5) {
        this.fromDateBienDong = new Date(new Date().getFullYear(), 1, 1);
        this.toDateBienDong = new Date(new Date().getFullYear(), 2, 0);
      }
      //6.Thang 3
      else if (this.kyBaoCao_Report4 == 6) {
        this.fromDateBienDong = new Date(new Date().getFullYear(), 2, 1);
        this.toDateBienDong = new Date(new Date().getFullYear(), 2, 31);
      }
      //7.Thang 4
      else if (this.kyBaoCao_Report4 == 7) {
        this.fromDateBienDong = new Date(new Date().getFullYear(), 3, 1);
        this.toDateBienDong = new Date(new Date().getFullYear(), 3, 30);
      }
      //8.Thang 5
      else if (this.kyBaoCao_Report4 == 8) {
        this.fromDateBienDong = new Date(new Date().getFullYear(), 4, 1);
        this.toDateBienDong = new Date(new Date().getFullYear(), 4, 31);
      }
      //9.Thang 6
      else if (this.kyBaoCao_Report4 == 9) {
        this.fromDateBienDong = new Date(new Date().getFullYear(), 5, 1);
        this.toDateBienDong = new Date(new Date().getFullYear(), 5, 30);
      }
      //10.Thang 7
      else if (this.kyBaoCao_Report4 == 10) {
        this.fromDateBienDong = new Date(new Date().getFullYear(), 6, 1);
        this.toDateBienDong = new Date(new Date().getFullYear(), 6, 31);
      }
      //11.Thang 8
      else if (this.kyBaoCao_Report4 == 11) {
        this.fromDateBienDong = new Date(new Date().getFullYear(), 7, 1);
        this.toDateBienDong = new Date(new Date().getFullYear(), 7, 31);
      }
      //12.Thang 9
      else if (this.kyBaoCao_Report4 == 12) {
        this.fromDateBienDong = new Date(new Date().getFullYear(), 8, 1);
        this.toDateBienDong = new Date(new Date().getFullYear(), 8, 30);
      }
      //13.Thang 10
      else if (this.kyBaoCao_Report4 == 13) {
        this.fromDateBienDong = new Date(new Date().getFullYear(), 9, 1);
        this.toDateBienDong = new Date(new Date().getFullYear(), 9, 31);
      }
      //14.Thang 11
      else if (this.kyBaoCao_Report4 == 14) {
        this.fromDateBienDong = new Date(new Date().getFullYear(), 10, 1);
        this.toDateBienDong = new Date(new Date().getFullYear(), 10, 30);
      }
      //15.Thang 12
      else if (this.kyBaoCao_Report4 == 15) {
        this.fromDateBienDong = new Date(new Date().getFullYear(), 11, 1);
        this.toDateBienDong = new Date(new Date().getFullYear(), 11, 31);
      }
      //16.Quy I
      else if (this.kyBaoCao_Report4 == 16) {
        this.fromDateBienDong = new Date(new Date().getFullYear(), 0, 1);
        this.toDateBienDong = new Date(new Date().getFullYear(), 2, 31);
      }
      //17.Quy II
      else if (this.kyBaoCao_Report4 == 17) {
        this.fromDateBienDong = new Date(new Date().getFullYear(), 3, 1);
        this.toDateBienDong = new Date(new Date().getFullYear(), 5, 30);
      }
      //18.Quy III
      else if (this.kyBaoCao_Report4 == 18) {
        this.fromDateBienDong = new Date(new Date().getFullYear(), 6, 1);
        this.toDateBienDong = new Date(new Date().getFullYear(), 8, 30);
      }
      //19.Quy IV
      else if (this.kyBaoCao_Report4 == 19) {
        this.fromDateBienDong = new Date(new Date().getFullYear(), 9, 1);
        this.toDateBienDong = new Date(new Date().getFullYear(), 11, 31);
      }
    },
    //Report 5: Change option Ky Bao Cao
    changeKyBaoCao_Report5() {
      //Today
      // if (this.kyBaoCao_Report5 == 0) {
      //   this.fromDateBirthday = new Date();
      //   this.toDateBirthday = new Date();
      // }
      // //Tomorrow
      // else if (this.kyBaoCao_Report5 == 1) {
      //   this.fromDateBirthday = new Date().setDate(new Date().getDate() + 1);
      //   this.toDateBirthday = new Date().setDate(new Date().getDate() + 1);
      // }
      // //This month
      // else if (this.kyBaoCao_Report5 == 2) {
      //   this.fromDateBirthday = new Date(
      //     new Date().getFullYear(),
      //     new Date().getMonth(),
      //     1
      //   );
      //   this.toDateBirthday = new Date(
      //     new Date().getFullYear(),
      //     new Date().getMonth() + 1,
      //     0
      //   );
      // }
      // //Next month
      // else if (this.kyBaoCao_Report5 == 3) {
      //   let fromDate = new Date(
      //     new Date().getFullYear(),
      //     new Date().getMonth(),
      //     1
      //   );
      //   let toDate = new Date(
      //     new Date().getFullYear(),
      //     new Date().getMonth() + 1,
      //     0
      //   );
      //   this.fromDateBirthday = new Date(
      //     fromDate.setMonth(fromDate.getMonth() + 1)
      //   );
      //   this.toDateBirthday = new Date(toDate.setMonth(toDate.getMonth() + 1));
      // }
      //4.Thang 1
      if (this.kyBaoCao_Report5 == 0) {
        this.fromDateBirthday = new Date(new Date().getFullYear(), 0, 1);
        this.toDateBirthday = new Date(new Date().getFullYear(), 0, 31);
      }
      //5.Thang 2
      else if (this.kyBaoCao_Report5 == 1) {
        this.fromDateBirthday = new Date(new Date().getFullYear(), 1, 1);
        this.toDateBirthday = new Date(new Date().getFullYear(), 2, 0);
      }
      //6.Thang 3
      else if (this.kyBaoCao_Report5 == 2) {
        this.fromDateBirthday = new Date(new Date().getFullYear(), 2, 1);
        this.toDateBirthday = new Date(new Date().getFullYear(), 2, 31);
      }
      //7.Thang 4
      else if (this.kyBaoCao_Report5 == 3) {
        this.fromDateBirthday = new Date(new Date().getFullYear(), 3, 1);
        this.toDateBirthday = new Date(new Date().getFullYear(), 3, 30);
      }
      //8.Thang 5
      else if (this.kyBaoCao_Report5 == 4) {
        this.fromDateBirthday = new Date(new Date().getFullYear(), 4, 1);
        this.toDateBirthday = new Date(new Date().getFullYear(), 4, 31);
      }
      //9.Thang 6
      else if (this.kyBaoCao_Report5 == 5) {
        this.fromDateBirthday = new Date(new Date().getFullYear(), 5, 1);
        this.toDateBirthday = new Date(new Date().getFullYear(), 5, 30);
      }
      //10.Thang 7
      else if (this.kyBaoCao_Report5 == 6) {
        this.fromDateBirthday = new Date(new Date().getFullYear(), 6, 1);
        this.toDateBirthday = new Date(new Date().getFullYear(), 6, 31);
      }
      //11.Thang 8
      else if (this.kyBaoCao_Report5 == 7) {
        this.fromDateBirthday = new Date(new Date().getFullYear(), 7, 1);
        this.toDateBirthday = new Date(new Date().getFullYear(), 7, 31);
      }
      //12.Thang 9
      else if (this.kyBaoCao_Report5 == 8) {
        this.fromDateBirthday = new Date(new Date().getFullYear(), 8, 1);
        this.toDateBirthday = new Date(new Date().getFullYear(), 8, 30);
      }
      //13.Thang 10
      else if (this.kyBaoCao_Report5 == 9) {
        this.fromDateBirthday = new Date(new Date().getFullYear(), 9, 1);
        this.toDateBirthday = new Date(new Date().getFullYear(), 9, 31);
      }
      //14.Thang 11
      else if (this.kyBaoCao_Report5 == 10) {
        this.fromDateBirthday = new Date(new Date().getFullYear(), 10, 1);
        this.toDateBirthday = new Date(new Date().getFullYear(), 10, 30);
      }
      //15.Thang 12
      else if (this.kyBaoCao_Report5 == 11) {
        this.fromDateBirthday = new Date(new Date().getFullYear(), 11, 1);
        this.toDateBirthday = new Date(new Date().getFullYear(), 11, 31);
      }
    },
    // Report 6 old: Change option Ky Bao Cao Report 5
    // changeKyBaoCao_Report6() {
    //   //Today
    //   if (this.kyBaoCao_Report6 == 0) {
    //     this.toDateChuaKyHD = new Date();
    //   }
    //   //Tomorrow
    //   else if (this.kyBaoCao_Report6 == 1) {
    //     this.toDateChuaKyHD = new Date().setDate(new Date().getDate() + 1);
    //   }
    //   //End of this month
    //   else if (this.kyBaoCao_Report6 == 2) {
    //     this.toDateChuaKyHD = new Date(
    //       new Date().getFullYear(),
    //       new Date().getMonth() + 1,
    //       0
    //     );
    //   }
    //   //End of next month
    //   else if (this.kyBaoCao_Report6 == 3) {
    //     let toDate = new Date(
    //       new Date().getFullYear(),
    //       new Date().getMonth() + 1,
    //       0
    //     );
    //     this.toDateChuaKyHD = new Date(toDate.setMonth(toDate.getMonth() + 1));
    //   }
    // },

    //Report 7: Change option Ky Bao Cao Report 7
    // changeKyBaoCao_Report7() {
    //   //Today
    //   if (this.kyBaoCao_Report7 == 0) {
    //     this.toDateSapHetHanHD = new Date();
    //   }
    //   //Tomorrow
    //   else if (this.kyBaoCao_Report7 == 1) {
    //     this.toDateSapHetHanHD = new Date().setDate(new Date().getDate() + 1);
    //   }
    //   //End of this month
    //   else if (this.kyBaoCao_Report7 == 2) {
    //     this.toDateSapHetHanHD = new Date(
    //       new Date().getFullYear(),
    //       new Date().getMonth() + 1,
    //       0
    //     );
    //   }
    //   //End of next month
    //   else if (this.kyBaoCao_Report7 == 3) {
    //     let toDate = new Date(
    //       new Date().getFullYear(),
    //       new Date().getMonth() + 1,
    //       0
    //     );
    //     this.toDateSapHetHanHD = new Date(
    //       toDate.setMonth(toDate.getMonth() + 1)
    //     );
    //   }
    // },

    //Report 7: Change option Ky Bao Cao Report 7
    changeKyBaoCao_Report8() {
      //Today
      if (this.kyBaoCao_Report8 == 0) {
        this.toDateQuaHan = new Date();
      }
      //Tomorrow
      else if (this.kyBaoCao_Report8 == 1) {
        this.toDateQuaHan = new Date().setDate(new Date().getDate() + 1);
      }
      //End of this month
      else if (this.kyBaoCao_Report8 == 2) {
        this.toDateQuaHan = new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
        );
      }
      //End of next month
      else if (this.kyBaoCao_Report8 == 3) {
        let toDate = new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
        );
        this.toDateQuaHan = new Date(toDate.setMonth(toDate.getMonth() + 1));
      }
    },

    //Report 9: Change option Ky Bao Cao
    changeKyBaoCao_Report9() {
      //Today
      if (this.kyBaoCao_Report9 == 0) {
        this.fromDateThayDoiLuong = new Date();
        this.toDateThayDoiLuong = new Date();
      }
      //Tháng này
      else if (this.kyBaoCao_Report9 == 1) {
        this.fromDateThayDoiLuong = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        );
        this.toDateThayDoiLuong = new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
        );
      }
      //2.Nam nay
      else if (this.kyBaoCao_Report9 == 2) {
        this.fromDateThayDoiLuong = new Date(new Date().getFullYear(), 0, 1);
        this.toDateThayDoiLuong = new Date(new Date().getFullYear(), 11, 31);
      }
      //3.Thang truoc
      else if (this.kyBaoCao_Report9 == 3) {
        let fromDate = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        );
        let toDate = new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
        );
        this.fromDateThayDoiLuong = new Date(
          fromDate.setMonth(fromDate.getMonth() - 1)
        );
        this.toDateThayDoiLuong = new Date(
          this.fromDateThayDoiLuong.getFullYear(),
          this.fromDateThayDoiLuong.getMonth() + 1,
          0
        );
      }
      //4.Nam truoc
      else if (this.kyBaoCao_Report9 == 4) {
        this.fromDateThayDoiLuong = new Date(
          new Date().getFullYear() - 1,
          0,
          1
        );
        this.toDateThayDoiLuong = new Date(
          new Date().getFullYear() - 1,
          11,
          31
        );
      }
      //5.Thang 1
      else if (this.kyBaoCao_Report9 == 5) {
        this.fromDateThayDoiLuong = new Date(new Date().getFullYear(), 0, 1);
        this.toDateThayDoiLuong = new Date(new Date().getFullYear(), 0, 31);
      }
      //6.Thang 2
      else if (this.kyBaoCao_Report9 == 6) {
        this.fromDateThayDoiLuong = new Date(new Date().getFullYear(), 1, 1);
        this.toDateThayDoiLuong = new Date(new Date().getFullYear(), 2, 0);
      }
      //7.Thang 3
      else if (this.kyBaoCao_Report9 == 7) {
        this.fromDateThayDoiLuong = new Date(new Date().getFullYear(), 2, 1);
        this.toDateThayDoiLuong = new Date(new Date().getFullYear(), 2, 31);
      }
      //8.Thang 4
      else if (this.kyBaoCao_Report9 == 8) {
        this.fromDateThayDoiLuong = new Date(new Date().getFullYear(), 3, 1);
        this.toDateThayDoiLuong = new Date(new Date().getFullYear(), 3, 30);
      }
      //9.Thang 5
      else if (this.kyBaoCao_Report9 == 9) {
        this.fromDateThayDoiLuong = new Date(new Date().getFullYear(), 4, 1);
        this.toDateThayDoiLuong = new Date(new Date().getFullYear(), 4, 31);
      }
      //10.Thang 6
      else if (this.kyBaoCao_Report9 == 10) {
        this.fromDateThayDoiLuong = new Date(new Date().getFullYear(), 5, 1);
        this.toDateThayDoiLuong = new Date(new Date().getFullYear(), 5, 30);
      }
      //11.Thang 7
      else if (this.kyBaoCao_Report9 == 11) {
        this.fromDateThayDoiLuong = new Date(new Date().getFullYear(), 6, 1);
        this.toDateThayDoiLuong = new Date(new Date().getFullYear(), 6, 31);
      }
      //12.Thang 8
      else if (this.kyBaoCao_Report9 == 12) {
        this.fromDateThayDoiLuong = new Date(new Date().getFullYear(), 7, 1);
        this.toDateThayDoiLuong = new Date(new Date().getFullYear(), 7, 31);
      }
      //13.Thang 9
      else if (this.kyBaoCao_Report9 == 13) {
        this.fromDateThayDoiLuong = new Date(new Date().getFullYear(), 8, 1);
        this.toDateThayDoiLuong = new Date(new Date().getFullYear(), 8, 30);
      }
      //14.Thang 10
      else if (this.kyBaoCao_Report9 == 14) {
        this.fromDateThayDoiLuong = new Date(new Date().getFullYear(), 9, 1);
        this.toDateThayDoiLuong = new Date(new Date().getFullYear(), 9, 31);
      }
      //15.Thang 11
      else if (this.kyBaoCao_Report9 == 15) {
        this.fromDateThayDoiLuong = new Date(new Date().getFullYear(), 10, 1);
        this.toDateThayDoiLuong = new Date(new Date().getFullYear(), 10, 30);
      }
      //16.Thang 12
      else if (this.kyBaoCao_Report9 == 16) {
        this.fromDateThayDoiLuong = new Date(new Date().getFullYear(), 11, 1);
        this.toDateThayDoiLuong = new Date(new Date().getFullYear(), 11, 31);
      }
      //17.Quy I
      else if (this.kyBaoCao_Report9 == 17) {
        this.fromDateThayDoiLuong = new Date(new Date().getFullYear(), 0, 1);
        this.toDateThayDoiLuong = new Date(new Date().getFullYear(), 2, 31);
      }
      //18.Quy II
      else if (this.kyBaoCao_Report9 == 18) {
        this.fromDateThayDoiLuong = new Date(new Date().getFullYear(), 3, 1);
        this.toDateThayDoiLuong = new Date(new Date().getFullYear(), 5, 30);
      }
      //19.Quy III
      else if (this.kyBaoCao_Report9 == 19) {
        this.fromDateThayDoiLuong = new Date(new Date().getFullYear(), 6, 1);
        this.toDateThayDoiLuong = new Date(new Date().getFullYear(), 8, 30);
      }
      //20.Quy IV
      else if (this.kyBaoCao_Report9 == 20) {
        this.fromDateThayDoiLuong = new Date(new Date().getFullYear(), 9, 1);
        this.toDateThayDoiLuong = new Date(new Date().getFullYear(), 11, 31);
      }
    },
    //Report 10
    changeReportKind() {
      // if (this.reportKind == 10 && this.employees.length <= 0) {
      //   axios
      //     .get("/api/employee/getbydepartment")
      //     .then((response) => {
      //       this.employees = response.data;
      //     })
      //     .catch((err) => {});
      // }
      // this.kyBaoCao_Report10 = null;
      this.kyBaoCao_Report10 = null;
    },

    excelReport() {
      let query = Object.assign({}, this.$route.query);
      query.report = this.report;
      // Parameter for report
      if (this.report == 2) query.toDate = this.toDateThamNien;
      if (this.report == 4) {
        query.fromDate = this.fromDateBienDong;
        query.toDate = this.toDateBienDong;
        query.status = this.tinhTrang_Report4;
      }

      if (this.report == 5) {
        query.fromDate = this.fromDateBirthday;
        query.toDate = this.toDateBirthday;
      }
      // if (this.report == 6) query.toDate = this.toDateChuaKyHD;
      // if (this.report == 7) {
      //   query.loaihopdong = this.loaihopdong;
      //   query.inDays = this.inDays_Report7;
      //   query.toDate = this.toDateSapHetHanHD;
      // }
      if (this.report == 8) {
        query.loaihopdong = this.loaihopdong;
        query.toDate = this.toDateQuaHan;
      }
      if (this.report == 9) {
        query.fromDate = this.fromDateThayDoiLuong;
        query.toDate = this.toDateThayDoiLuong;
      }
      // if (this.report == 10) query.employee = this.employee.id;
      if (this.report == 10) query.employee = this.kyBaoCao_Report10;
      axios({
        method: "get",
        url: `/api/employeereport/report`,
        params: query,
        responseType: "blob", // important
      })
        .then((res) => {
          let filename = res.headers["content-disposition"]
            .split(";")
            .find(function(el) {
              if (el.includes("filename=")) return el;
            })
            .replace("filename=", "")
            .trim();
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          //   reject(err);
        });
      //window.open(`/api/employeeeport?report=${this.report}`, "_blank");
      //   axios
      //     .get(`/api/employeereport?report=${this.report}`)
      //     .then((response) => {})
      //     .catch((err) => {
      //       this.$toast.error(err.response.data, "Lỗi", {
      //         timeout: 3000,
      //      });
      //     });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
